import {AfterViewInit, Component, OnInit, Renderer2} from "@angular/core";
import {HtmlTemplateVar} from "../../../../../dto/templates/html-template-var";
import {HtmlEditorComponent} from "../../../../../shared/html-editor/html-editor.component";
import {PushNotificationTemplatesService} from "../../../../../services/crud/push-notification-templates.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {PushNotificationTemplate} from "../../../../../dto/templates/html-template";


@Component({
  selector: 'app-push-notification-templates-edit',
  templateUrl: './push-notification-templates-edit.component.html',
  styleUrls: ['./push-notification-templates-edit.component.css']
})
export class PushNotificationTemplatesEditComponent implements OnInit, AfterViewInit  {

  commands: HtmlTemplateVar[];

  id: number;

  selectedLanguage = 0;

  lastFocusedElement: any;

  constructor(
    private templatesService: PushNotificationTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
  ) { }

  templateForm: FormGroup;

  selectLanguage(lang: number){

    if( Number.isNaN(this.id) ){
      alert('English template must be saved first.');
      return;
    }

    if (this.templateForm.dirty){
      if(!confirm('Changes not saved. Do you want to proceed?')){
        return;
      }
    }

    this.navigateToLanguage(lang);

  }

  navigateToLanguage(lang: number){
    window.location.href = '/administration/templates/push-notification/'+this.id+'?lang='+lang;
  }

    ngAfterViewInit(): void {
        const formElement = this.renderer.selectRootElement('.content-card', true);
        if (formElement) {
            formElement.addEventListener('focusin', (event: FocusEvent) => {
                const target = event.target as HTMLElement;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    this.lastFocusedElement = target;
                }
            });
        }
    }

  ngOnInit() {

    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    const lang = parseInt(this.route.snapshot.queryParamMap.get('lang'));

    if( Number.isNaN(lang) ){
      this.selectedLanguage = 1;
    }else{
      this.selectedLanguage = lang;
    }

    if (Number.isNaN(this.id)) {
      this.initForm(new PushNotificationTemplate());
    } else {
      this.templatesService.get(this.id).subscribe(result => {
        this.initForm(result);
      });
    }
  }

    insert(text: string) {
        if (this.lastFocusedElement) {

          const text2 = '*|' + text + '|*';

          const input = this.lastFocusedElement as HTMLInputElement;
          const start = input.selectionStart || 0;
          const end = input.selectionEnd || 0;
          const originalValue = input.value;
          input.value = originalValue.substring(0, start) + text2 + originalValue.substring(end);
          input.setSelectionRange(start + text2.length, start + text2.length); // Move the cursor after the inserted text
          input.focus();

          // Find the form control name based on the input element
          const controlName = input.getAttribute('formControlName');
          if (controlName) {
            const ctrl = this.templateForm.get(controlName);
            ctrl?.setValue(input.value);
            ctrl?.updateValueAndValidity();
          }

        }
    }

  initForm(template: PushNotificationTemplate) {

    this.templateForm = this.formBuilder.group({
      id: template.id,
      name: template.name,

      bodyTitleDe: template.bodyTitleDe,
      bodyTextDe: template.bodyTextDe,
      bodyTitleEn: template.bodyTitleEn,
      bodyTextEn: template.bodyTextEn,
      notificationTitleDe: template.notificationTitleDe,
      notificationTextDe: template.notificationTextDe,
      notificationTitleEn: template.notificationTitleEn,
      notificationTextEn: template.notificationTextEn,

      action: template.action ?? "",
      actionParameter: template.actionParameter ?? "",
      actionLabelDe: template.actionLabelDe,
      actionLabelEn: template.actionLabelEn,



    });


    this.templatesService.getVars().subscribe(result => {
      this.commands = result.data;
    });
  }

  goBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  onSubmit(form: FormGroup) {
    if (Number.isNaN(this.id)) {
      this.templatesService.add(form.value).subscribe(res => {
        this.id = res;
        this.navigateToLanguage(this.selectedLanguage);
      });
    } else {
      this.templatesService.update(this.id, form.value).subscribe(res => this.navigateToLanguage(this.selectedLanguage));
    }
  }


  onFocus(event: FocusEvent) {
    this.lastFocusedElement = event.target;
  }

  onEmojiSelected(emoji: string) {
    if (this.lastFocusedElement) {

      const text2 = emoji;

      const input = this.lastFocusedElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const originalValue = input.value;
      input.value = originalValue.substring(0, start) + text2 + originalValue.substring(end);
      input.setSelectionRange(start + text2.length, start + text2.length); // Move the cursor after the inserted text
      input.focus();

      // Find the form control name based on the input element
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        const ctrl = this.templateForm.get(controlName);
        ctrl?.setValue(input.value);
        ctrl?.updateValueAndValidity();
      }

    }
  }
}
